import { table } from 'console';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, selectUserLoggedIn } from '../../modules';
import { Button, Empty, Spin, Badge } from 'antd';
import { useHistory } from 'react-router';
import {
    fetchUserAssetsRequest,
    fetchUserPnLRequest,
    fetchUserPnLExpectedRequest,
} from '../../modules/user/assets/actions';
import {
    fetchOrderHistoryRequest,
    fetchOrderMatchHistoryRequest,
    selectStockOrderHistoryData,
    selectStockOrderHistoryLoading,
    OrderHistoryStatus,
    OrderHistoryData,
    selectStockOrderMatchHistoryData,
    selectStockOrderMatchHistoryLoading,
} from '../../modules/user/stock-order-history';
import { DataOrderType } from '../TableOrder';
import { getStatusText } from '../../helpers/getStatusText';
import { fetchCancelOrderRequest } from '../../modules/user/stock-order/actions';
import { OpenOrderData } from '../../modules/user/stock-order/types';
import { selectCancelOrderLoading } from '../../modules/user/stock-order/selector';
import { selectUserAssetsData, selectUserAssetsDataLoading } from '../../modules/user/assets/selector';
import { DataUserAssetsType } from '../TableInventory';
import { filterOrderHistoryByStatus } from '../../helpers';
import moment from 'moment';
import { AntdModal } from '../../components/AntdModal';
import { DataOrderMatchType } from '../TableOrderMatch';

export function PriceBoardModalHistory() {
    const history = useHistory();
    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = React.useState('Orders');

    const isLogin = useSelector((state: RootState) => selectUserLoggedIn(state));

    React.useEffect(() => {
        if (isLogin) {
            dispatch(fetchUserAssetsRequest());
            dispatch(fetchOrderHistoryRequest());
            dispatch(fetchOrderMatchHistoryRequest());
            dispatch(fetchUserPnLRequest());
            dispatch(fetchUserPnLExpectedRequest());
        }

    }, [dispatch]);

    const dataOrderHistory = useSelector(selectStockOrderHistoryData) as unknown as DataOrderType[];
    const isDataLoadingOrderHistory = useSelector(selectStockOrderHistoryLoading);

    const [openCancelModal, setOpenCancelModal] = React.useState(false);
    const cancelLoading = useSelector((state: RootState) => selectCancelOrderLoading(state));
    const [cancel, setCancel] = React.useState<OpenOrderData>();

    const showModal = (cancel: OpenOrderData) => {
        setOpenCancelModal(true);
        setCancel(cancel);
    };
    const cancelModal = () => {
        setOpenCancelModal(false);
        setCancel(undefined);
    };
    const handleCancelOrder = () => {
        if (cancel) {
            dispatch(fetchCancelOrderRequest({ id: cancel.id, ticker: cancel.ticker }));
        }
    };
    React.useEffect(() => {
        if (!cancelLoading) {
            setOpenCancelModal(false);
            setCancel(undefined);
        }
    }, [cancelLoading]);
    const canCancelled = (status: OrderHistoryStatus) => {
        return status === 'partially_filled' || status === 'pending';
    };

    function renderOrdersTab() {
        const tableHeaders = [
            { label: 'Symbol', width: '16.66%' },
            { label: 'Side', width: '16.66%' },
            { label: 'Type', width: '16.66%' },
            { label: 'Quantity', width: '16.66%' },
            { label: 'Matched', width: '16.66%' },
            { label: 'Price', width: '16.66%' },
            { label: 'Status', width: '16.66%' },
            { label: 'Action', width: '16.66%' },
        ];

        const totalQuantity = dataOrderHistory?.reduce((acc, order) => acc + (Number(order.totalAmount) || 0), 0) || 0;

        const totalMatchedQuantity =
            dataOrderHistory?.reduce((acc, order) => acc + (Number(order.filledAmount) || 0), 0) || 0;

        return (
            <div className="price-board__buy-modal__history__body price-board__buy-modal__history__body--orders">
                <div className="price-board__buy-modal__history__body__info" data-tour="buy-modal-orders-summary">
                    <div className="price-board__buy-modal__history__body__info__item">
                        <div className="price-board__buy-modal__history__body__info__item__label">Total quantity:</div>
                        <div className="price-board__buy-modal__history__body__info__item__value">
                            {totalQuantity.toLocaleString()}
                        </div>
                    </div>
                    <div className="price-board__buy-modal__history__body__info__item">
                        <div className="price-board__buy-modal__history__body__info__item__label">
                            Total matched quantity:
                        </div>
                        <div className="price-board__buy-modal__history__body__info__item__value">
                            {totalMatchedQuantity.toLocaleString()}
                        </div>
                    </div>
                </div>
                <table className="price-board__buy-modal__history__body__table" data-tour="buy-modal-orders-table">
                    <thead className="price-board__buy-modal__history__body__table__header">
                        {tableHeaders.map((header, index) => (
                            <th
                                key={index}
                                style={{ width: header.width }}
                                className="price-board__buy-modal__history__body__table__header__item">
                                {header.label}
                            </th>
                        ))}
                    </thead>
                    {isLogin ? (
                        <>
                            {isDataLoadingOrderHistory ? (
                                <tr>
                                    <td colSpan={tableHeaders.length} style={{ textAlign: 'center' }}>
                                        <Spin />
                                    </td>
                                </tr>
                            ) : dataOrderHistory && dataOrderHistory.length > 0 ? (
                                dataOrderHistory.map((order, index) => (
                                    <tr className="price-board__buy-modal__history__body__table__row" key={index}>
                                        <td>{order.ticker}</td>
                                        <td>{order.side === 'buy' ? 'Buy' : 'Sell'}</td>
                                        <td
                                            style={{
                                                color:
                                                    order.type === 'market'
                                                        ? 'var(--text-buy-color)'
                                                        : 'var(--text-sell-color)',
                                            }}>
                                            {order.type === 'market' ? 'Market' : 'Limit'}
                                        </td>
                                        <td>{Number(order.totalAmount)?.toLocaleString() || 0}</td>
                                        <td>{Number(order.filledAmount)?.toLocaleString() || 0}</td>
                                        <td>{Number(order.price)?.toLocaleString() || 0}</td>
                                        <td>{getStatusText(order.status)}</td>
                                        <td>
                                            {canCancelled(order.status) && (
                                                <Button
                                                    type="link"
                                                    danger
                                                    style={{ fontSize: '12px' }}
                                                    onClick={() => showModal(order as unknown as OpenOrderData)}>
                                                    Cancel
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr className="price-board__buy-modal__history__body__table__not-found">
                                    <td colSpan={tableHeaders.length}>
                                        <Empty />
                                    </td>
                                </tr>
                            )}
                        </>
                    ) : (
                        <tr className="price-board__buy-modal__history__body__table__login-register">
                            <td colSpan={tableHeaders.length}>
                                <Button
                                    className="price-board__buy-modal__body__buttons--login"
                                    onClick={() => history.push('/signin')}>
                                    Register/Login
                                </Button>
                            </td>
                        </tr>
                    )}
                </table>
            </div>
        );
    }
    const dataOrderMatch = useSelector(selectStockOrderMatchHistoryData) as unknown as DataOrderMatchType[];
    const isDataLoadingOrderMatch = useSelector(selectStockOrderMatchHistoryLoading);
    const getT2StatusText = (settlementDate: string | undefined) => {
        console.log(settlementDate);
        if (!settlementDate) return null;
        const now = new Date();
        now.setHours(9, 0, 0, 0);
        const settlement = new Date(settlementDate);
    
        // Tính số mili giây chênh lệch
        const diffTime = settlement.getTime() - now.getTime();
        // Số ngày thực (bao gồm phần thập phân)
        let diffDays = diffTime / (1000 * 60 * 60 * 24);
    
        // Làm tròn lên theo 0.5 ngày
        diffDays = Math.ceil(diffDays * 2) / 2;
    
        if (diffDays <= 0) {
            return <span style={{ color: 'green' }}>Completed</span>;
        } else if (diffDays === 0.5) {
            return <span style={{ color: 'green' }}>T+0.5</span>;
        } else if (diffDays === 1) {
            return <span style={{ color: 'yellow' }}>T+1</span>;
        } else if (diffDays === 1.5) {
            return <span style={{ color: 'yellow' }}>T+1.5</span>;
        } else if (diffDays === 2) {
            return <span style={{ color: 'orange' }}>T+2</span>;
        } else if (diffDays === 2.5) {
            return <span style={{ color: 'orange' }}>T+2.5</span>;
        } else {
            return <span style={{ color: 'red' }}>T+{diffDays}</span>;
        }
    };
    function renderOrdersMatchTab() {
        const tableHeaders = [
            { label: 'Symbol', width: '16.66%' },
            { label: 'Amount', width: '16.66%' },
            { label: 'Price', width: '16.66%' },
            { label: 'Side', width: '16.66%' },
            { label: 'Created At', width: '16.66%' },
            { label: 'Status', width: '16.66%' },
        ];

        return (
            <div className="price-board__buy-modal__history__body price-board__buy-modal__history__body--orders">
                <div className="price-board__buy-modal__history__body__info">
                    <div className="price-board__buy-modal__history__body__info__item">
                        <div className="price-board__buy-modal__history__body__info__item__label">Total quantity:</div>
                        <div className="price-board__buy-modal__history__body__info__item__value">
                            {dataOrderMatch.length}
                        </div>
                    </div>
                </div>
                <table className="price-board__buy-modal__history__body__table">
                    <thead className="price-board__buy-modal__history__body__table__header">
                        {tableHeaders.map((header, index) => (
                            <th
                                key={index}
                                style={{ width: header.width }}
                                className="price-board__buy-modal__history__body__table__header__item">
                                {header.label}
                            </th>
                        ))}
                    </thead>
                    {isLogin ? (
                        <>
                            {isDataLoadingOrderMatch ? (
                                <tr>
                                    <td colSpan={tableHeaders.length} style={{ textAlign: 'center' }}>
                                        <Spin />
                                    </td>
                                </tr>
                            ) : dataOrderMatch && dataOrderMatch.length > 0 ? (
                                dataOrderMatch.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).map((order, index) => (
                                    <tr className="price-board__buy-modal__history__body__table__row" key={index}>
                                        <td>{order.ticker}</td>
                                        <td>{Number(order.amount)?.toLocaleString() || 0}</td>
                                        <td>{Number(order.price)?.toLocaleString() || 0}</td>
                                        <td style={{ color: order.side === 'buy' ? 'green' : 'red' }}>
                                            {order.side === 'buy' ? 'Buy' : 'Sell'}
                                        </td>
                                    
                                        <td>{moment(order.createdAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                                            <td>{getT2StatusText(order?.settlementDate)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr className="price-board__buy-modal__history__body__table__not-found">
                                    <td colSpan={tableHeaders.length}>
                                        <Empty />
                                    </td>
                                </tr>
                            )}
                        </>
                    ) : (
                        <tr className="price-board__buy-modal__history__body__table__login-register">
                            <td colSpan={tableHeaders.length}>
                                <Button
                                    className="price-board__buy-modal__body__buttons--login"
                                    onClick={() => history.push('/signin')}>
                                    Register/Login
                                </Button>
                            </td>
                        </tr>
                    )}
                </table>
            </div>
        );
    }

    const dataUserAssets = useSelector(selectUserAssetsData).portfolios as unknown as DataUserAssetsType[];
    const isLoadingAssets = useSelector(selectUserAssetsDataLoading);
    const orderHistory = useSelector(selectStockOrderHistoryData);
    const orderHistoryPending = filterOrderHistoryByStatus(orderHistory, ['pending']);
    const orderHistoryPartially = filterOrderHistoryByStatus(orderHistory, ['partially_filled']);

    const calculateTotalUnavailableAmount = (ticker: string) => {
        const sumTotalAmount = (orders: OrderHistoryData[]) =>
            orders
                .filter((item) => item.ticker === ticker && item.side === 'sell')
                .reduce((total, item) => total + Number(item.totalAmount), 0);

        const sumUnfilledAmount = (orders: OrderHistoryData[]) =>
            orders
                .filter((item) => item.ticker === ticker && item.side === 'sell')
                .reduce((total, item) => total + (Number(item.totalAmount) - Number(item.filledAmount)), 0);

        const amountPending = sumTotalAmount(orderHistoryPending);
        const amountPartially = sumUnfilledAmount(orderHistoryPartially);

        return amountPending + amountPartially;
    };

    function renderPortfolioTab() {
        const tableHeaders = [
            { label: 'Symbol', width: '20%' },
            { label: 'Available Volume', width: '20%' },
            { label: 'Total Volume', width: '20%' },
            { label: 'Last Update', width: '20%' },
        ];

        // const portfolioData =
        //     dataOrderHistory?.reduce(
        //         (acc, order) => {
        //             if (order.status === 'completed') {
        //                 const existingStock = acc.find((item) => item.ticker === order.ticker);
        //                 if (existingStock) {
        //                     if (order.side === 'buy') {
        //                         existingStock.quantity += order.filledAmount;
        //                         existingStock.totalValue += order.price * order.filledAmount;
        //                     } else {
        //                         existingStock.quantity -= order.filledAmount;
        //                         existingStock.totalValue -= order.price * order.filledAmount;
        //                     }
        //                 } else {
        //                     acc.push({
        //                         ticker: order.ticker,
        //                         quantity: order.side === 'buy' ? order.filledAmount : -order.filledAmount,
        //                         totalValue:
        //                             order.side === 'buy'
        //                                 ? order.price * order.filledAmount
        //                                 : -order.price * order.filledAmount,
        //                     });
        //                 }
        //             }
        //             return acc;
        //         },
        //         [] as { ticker: string; quantity: number; totalValue: number }[],
        //     ) || [];

        // const totalPortfolioValue = portfolioData.reduce((acc, stock) => acc + stock.totalValue, 0);

        return (
            <div className="price-board__buy-modal__history__body price-board__buy-modal__history__body--portfolio">
                <div className="price-board__buy-modal__history__body__info" data-tour="buy-modal-portfolio-summary">
                    <div className="price-board__buy-modal__history__body__info__item">
                        {/* <div className="price-board__buy-modal__history__body__info__item__label">Total:</div> */}
                        {/* <div className="price-board__buy-modal__history__body__info__item__value">
                            {totalPortfolioValue.toLocaleString()} VND
                        </div> */}
                    </div>
                </div>
                <table className="price-board__buy-modal__history__body__table" data-tour="buy-modal-portfolio-table">
                    <thead className="price-board__buy-modal__history__body__table__header">
                        {tableHeaders.map((header, index) => (
                            <th
                                key={index}
                                style={{ width: header.width }}
                                className="price-board__buy-modal__history__body__table__header__item">
                                {header.label}
                            </th>
                        ))}
                    </thead>
                    {isLogin ? (
                        <>
                            {isLoadingAssets ? (
                                <tr>
                                    <td colSpan={tableHeaders.length} className="text-center">
                                        <Spin />
                                    </td>
                                </tr>
                            ) : dataUserAssets && dataUserAssets.length > 0 ? (
                                dataUserAssets.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.ticker}</td>
                                        <td>{Number(item.amount)?.toLocaleString()}</td>
                                        <td>
                                            {(
                                                Number(item.amount) + calculateTotalUnavailableAmount(item.ticker)
                                            ).toLocaleString()}
                                        </td>
                                        <td>{moment(item.updateAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr className="price-board__buy-modal__history__body__table__not-found">
                                    <td colSpan={tableHeaders.length}>
                                        <Empty />
                                    </td>
                                </tr>
                            )}
                        </>
                    ) : (
                        <tr className="price-board__buy-modal__history__body__table__login-register">
                            <td colSpan={tableHeaders.length}>
                                <Button
                                    className="price-board__buy-modal__body__buttons--login"
                                    onClick={() => history.push('/signin')}>
                                    Register/Login
                                </Button>
                            </td>
                        </tr>
                    )}
                </table>
            </div>
        );
    }
    const userAssets = useSelector(selectUserAssetsData);
    const assetsWallet = Number(userAssets.wallet[0]?.balance);
    function renderAssetTab() {
        const listInfo = [
            { label: 'Total Asset', value: '0' },
            { label: 'Cash Balance', value: assetsWallet.toLocaleString() + ' VND' },
            { label: 'Value of listed securities', value: '-' },
            { label: 'Withdrawable Amount', value: '-' },
            { label: 'Liability', value: '-' },
            { label: 'Net Sell Value', value: '-' },
            { label: 'Advanced Cash', value: '-' },
            { label: 'Right Subcription', value: '-' },
            { label: 'Cash dividend', value: '-' },
        ];

        const totalAsset =
            dataOrderHistory?.reduce((acc, order) => {
                if (order.status === 'completed') {
                    const value =
                        order.side === 'buy' ? order.price * order.filledAmount : -order.price * order.filledAmount;
                    return acc + value;
                }
                return acc;
            }, 0) || 0;

        const updatedListInfo = listInfo.map((item) => {
            if (item.label === 'Total Asset') {
                return {
                    ...item,
                    value: (totalAsset + assetsWallet).toLocaleString() + ' VND',
                };
            }
            return item;
        });

        return (
            <div className="price-board__buy-modal__history__body price-board__buy-modal__history__body--asset">
                <div className="price-board__buy-modal__history__body__list">
                    {isLogin ? (
                        <>
                            {updatedListInfo.map((item, index) => (
                                <div key={index} className="price-board__buy-modal__history__body__list__item">
                                    <div className="price-board__buy-modal__history__body__list__item__label">
                                        {item.label}:
                                    </div>
                                    <div className="price-board__buy-modal__history__body__list__item__value">
                                        {item.value}
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : (
                        <Button
                            className="price-board__buy-modal__body__buttons--login"
                            onClick={() => history.push('/signin')}>
                            Register/Login
                        </Button>
                    )}
                </div>
            </div>
        );
    }

    const tabList = [
        {
            name: 'Orders',
            component: renderOrdersTab,
        },
        {
            name: 'Orders Match',
            component: renderOrdersMatchTab,
        },
        {
            name: 'Portfolio',
            component: renderPortfolioTab,
        },
        // {
        //     name: 'Asset',
        //     component: renderAssetTab,
        // },
    ];

    function renderHistoryBody() {
        const activeTabComponent = tabList.find((tab) => tab.name === activeTab);
        return activeTabComponent ? activeTabComponent.component() : null;
    }

    return (
        <div className="price-board__buy-modal__history" data-tour="buy-modal-history">
            <div className="price-board__buy-modal__history__tab" data-tour="buy-modal-history-tabs">
                {tabList.map((tab) => (
                    <div
                        key={tab.name}
                        className={`price-board__buy-modal__history__tab__item ${activeTab === tab.name ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.name)}>
                        {tab.name}
                    </div>
                ))}
            </div>
            {renderHistoryBody()}
            <AntdModal
                title="Are you sure to cancel this order?"
                open={openCancelModal}
                onCancel={cancelModal}
                onOk={handleCancelOrder}
                loading={cancelLoading}
            />
        </div>
    );
}
